module.exports = __webpack_public_path__ + "static/media/1008752.c08269e3.png";